import { Global, css } from '@emotion/react';
import type { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { SponsorsSliderWidget } from '../../../components/Widgets';

const SponsorsSlider = () => {
  const router = useRouter();
  const style = {
    globals: css`
      body {
        background: transparent;
      }
    `,
  };

  return (
    <>
      <Global styles={style.globals} />
      <SponsorsSliderWidget clubId={Number(router.query?.clubId)} />
    </>
  );
};

export const getStaticPaths: GetStaticPaths = () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'fr', [
      'snc-components',
      'snc-core',
      'common',
    ])),
  },
});

export default SponsorsSlider;
